import Session from "../Utils/Sessions";

// src/api.js
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
   const api = `${BASE_URL}api/v1/`;
// const api = 'https://bgi.sortstring.com/api/v1/';
//  const api = 'http://192.168.1.44:9000/api/v1/'
// const api2 = 'https://bgi.bitevns.org/api/v1/'
// const api =  "http://192.168.1.27:9000/api/v1/";
const api2 = api;
const token = localStorage.getItem('token');

// Create data
export const Postdata = async (Url, data) => {
  try {

    const token = Session.get('token');

    const response = await fetch(`${api}${Url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Token ${token}` }),
      },
      body: JSON.stringify(data),
      //   mode: 'no-cors',s
    });
    const result = await response.json();

    // // Emit transaction refresh event if this API should trigger refresh
    // if (shouldRefreshTransactions(Url)) {
    //   emitTransactionRefresh(Url);
    // }

    return result;
  } catch (error) {
    console.error("Error creating data:", error);
  }
};
export const PostdataWithoutToken = async (Url, data) => {
  try {
    const response = await fetch(`${api}${Url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error creating data:", error);
  }
};




export const PostdataWithJson = async (Url, data) => {
  try {
    const token = Session.get('token');
    const response = await fetch(`${api}${Url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Token ${token}` }),
      },
      body: JSON.stringify(data),
      //   mode: 'no-cors',s
    });
    return await response.json();
  } catch (error) {
    console.error("Error creating data:", error);
  }
};


export const Postdataform = async (Url, data) => {
  try {
    const token = Session.get('token');
    const response = await fetch(`${api}${Url}`, {
      method: 'POST',
      headers: {
        ...(token && { 'Authorization': `Token ${token}` }),
      },
      body: data,
      //   mode: 'no-cors',s
    });
    const result = await response.json();

    // Emit transaction refresh event if this API should trigger refresh
    // if (shouldRefreshTransactions(Url)) {
    //   emitTransactionRefresh(Url);
    // }

    return result;
  } catch (error) {
    console.error("Error creating data:", error);
  }
};

export const PostdataformPublic = async (Url, data) => {
  try {
    const response = await fetch(`${api}${Url}`, {
      method: "POST",
      body: data, // FormData
    });

    return await response.json();
  } catch (error) {
    console.error("Error creating public data:", error);
  }
};


export const UpdateDataForm = async (Url, data) => {
  try {
    const token = Session.get('token');
    const response = await fetch(`${api}${Url}`, {
      method: 'PUT',
      headers: {
        ...(token && { 'Authorization': `Token ${token}` }),
      },
      body: data,
      //   mode: 'no-cors',s
    });
    return await response.json();
  } catch (error) {
    console.error("Error creating data:", error);
  }
};

export const UpdateDataFormWithJson = async (Url, data) => {

  try {
    const token = Session.get('token');
    const response = await fetch(`${api}${Url}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Token ${token}`

      },
      body: JSON.stringify(data),
    });

    const result = await response.json();

    if (!response.ok) {
      return { error: result?.detail || 'Unknown error' };
    }

    return result;
  } catch (error) {
    console.error('Error:', error);
    return { error: 'Network or server error' };
  }
};

// Get all data
export const getData = async (Url) => {
  try {
    const token = Session.get('token');
    const response = await fetch(`${api}${Url}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Token ${token}` }),
      },

      //   mode: 'no-cors',s
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};


export const getSingleDataById = async (Url, id) => {
  try {
    const token = Session.get('token');
    const response = await fetch(`${api}${Url}/${id}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Token ${token}` }),
      },
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error(`Error fetching data by id from ${Url}:`, error);
  }
};



export const getDataformap = async (Url) => {
  try {
    const token = Session.get('token');
    const response = await fetch(`${api2}${Url}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Token ${token}` }),
      },

      //   mode: 'no-cors',s
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};
export const getDatalink = async (Url, tokenfromlink) => {
  try {
    const token = Session.get('token');
    const response = await fetch(`${window.api}${Url}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...(tokenfromlink && { 'Authorization': `Token ${tokenfromlink}` }),
      },

      //   mode: 'no-cors',s
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

// Get data by ID
export const getDataById = async (Url, id) => {
  try {
    const token = Session.get('token');
    const response = await fetch(`${Url}/data/${id}`);
    return await response.json();
  } catch (error) {
    console.error("Error fetching data by ID:", error);
  }
};

// Update data by ID
export const updateData = async (Url, updatedData) => {
  try {
    const token = Session.get('token');
    const response = await fetch(`${api}${Url}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Token ${token}` }),
      },
      body: JSON.stringify(updatedData),
    });

    return await response.json();
  } catch (error) {
    console.error("Error updating data:", error);
  }
};

// Delete data by ID
export const Deletedata = async (Url, id) => {
  try {
    const token = Session.get('token');
    const response = await fetch(`${Url}/data/${id}`, {
      method: 'DELETE',
    });
    return await response.json();
  } catch (error) {
    console.error("Error deleting data:", error);
  }
};

// src/api.js

// Patch data by ID (Partial update)
export const patchData = async (Url, updatedData) => {
  try {
    const token = Session.get('token');
    const response = await fetch(`${api}${Url}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Token ${token}` }),
      },
      body: JSON.stringify(updatedData),
    });
    return await response.json();
  } catch (error) {
    console.error("Error patching data:", error);
  }
};

// Put data by ID (Full update)
export const putData = async (Url, updatedData) => {
  try {
    const token = Session.get('token');
    const response = await fetch(`${api}${Url}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Token ${token}` }),
      },
      body: JSON.stringify(updatedData),
    });
    return await response.json();
  } catch (error) {
    console.error("Error putting data:", error);
  }
};

// Get a file (blob) like Excel/PDF
export const getBlob = async (Url) => {
  try {
    const token = Session.get('token');
    const response = await fetch(`${api}${Url}`, {
      method: 'GET',
      headers: {
        ...(token && { 'Authorization': `Token ${token}` })
      }
    });
    if (!response.ok) throw new Error("Network error or unauthorized");
    return await response.blob();
  } catch (error) {
    console.error("❌ Error downloading blob:", error);
    throw error;
  }
};


export const postBlob = async (Url, bodyData = {}) => {
  try {
    const token = Session.get('token');
    const response = await fetch(`${api}${Url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Token ${token}` })
      },
      body: JSON.stringify(bodyData)
    });

    if (!response.ok) throw new Error("Network error or unauthorized");
    return await response.blob();
  } catch (error) {
    console.error("❌ Error downloading blob:", error);
    throw error;
  }
};



export const getBloblive = async (Url) => {
  try {
    const token = Session.get('token');
    const response = await fetch(`${api2}${Url}`, {
      method: 'GET',
      headers: {
        ...(token && { 'Authorization': `Token ${token}` })
      }
    });
    if (!response.ok) throw new Error("Network error or unauthorized");
    return await response.blob();
  } catch (error) {
    console.error("❌ Error downloading blob:", error);
    throw error;
  }
};
export const postDataWithToken = async (Url, data, customToken) => {
  try {
    const token = Session.get('token');
    const response = await fetch(`${api}${Url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(customToken && { Authorization: `Token ${customToken}` })
      },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.error("Error posting data with token:", error);
    throw error;
  }
};




export const PostFileData = async (Url, fileFieldName, file) => {
  const formData = new FormData();
  formData.append(fileFieldName, file);

  try {

    const token = Session.get('token');
    const response = await fetch(`${api}${Url}`, {
      method: 'POST',
      headers: {
        ...(token && { 'Authorization': `Token ${token}` })
      },
      body: formData
    });

    const data = await response.json(); // parse JSON even on error

    if (!response.ok) {
      console.error("❌ Upload failed:", data);
      throw data; // Throw full error response to handle in UI
    }

    return data;
  } catch (error) {
    console.error("❌ Error uploading file:", error);
    throw error; // Bubble it up to show in UI
  }
};

